module.exports = __webpack_public_path__ + "img/ic_food_function_member_tabes_img2.f038f583.png";